// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* Store Custom Code - End */

const textArea: Styleguide["textArea"] = {
    /* Store Custom Code - Start */
    defaultProps: {
        css: css`
            border-radius: ${pxToRem(6)} !important; /* important required to override all possible states */
        `,
    },
    /* Store Custom Code - End */
};

export default textArea;
